<template>
  <v-container>
    <h2>{{ $t('Contact us') }}</h2>
    <v-card outlined class="r0 mt-5" style="padding: 7%">
      <!-- <p style="margin-bottom: 60px;">You can contact us through the following channels below</p> -->
      <v-row>
        <v-col cols="12" xs="12" md="6">
          <h4><v-icon class="mr-2">mdi-email</v-icon> {{ $t('Email') }}:</h4>
          <p>Sales@zwiz.ai</p>
          <h4><v-icon class="mr-2">mdi-phone</v-icon>{{ $t('Phone no.') }}</h4>
          <p>02-821-5535</p>
          <div>
            {{ $t('ZWIZ.AI Page at') }}
            <v-btn
              class="btn-custom messenger mb-3"
              style="background-color: #f5f5f5 !important"
              @click="facebook"
              ><v-icon color="#3b5998" class="mr-2">mdi-facebook</v-icon
              ><span style="color: #000000">Facebook</span>
            </v-btn>
          </div>
          <div>
            {{ $t('Contact the staff at') }}
            <v-btn
              class="btn-custom messenger"
              style="background-color: #f5f5f5 !important"
              @click="messenger"
              ><v-icon color="#3b5998" class="mr-2"
                >mdi-facebook-messenger</v-icon
              ><span style="color: #000000">Facebook Messenger</span>
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12" xs="12" md="6"
          ><h4>
            <v-icon color="primary" class="mr-2">mdi-map-marker</v-icon
            >{{ $t('Address') }}
          </h4>
          <h4>Robolingo Co.,Ltd.</h4>
          <p>
            {{
              $t(
                'ZWIZ.AI 998/3 Soi Phahon Yothin 18/1, Chom Phon, Chatuchak, Bangkok 10900'
              )
            }}
          </p>

          <div>
            <h4>{{ $t('Registration No') }}:</h4>
            <p>0105560189633</p>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <!-- <div style="float: right;">
      <div class="box-left pointer">
        <v-icon @click="facebook">mdi-facebook</v-icon>
      </div>
      <div class="box-right pointer">
        <v-icon @click="messenger">mdi-facebook-messenger</v-icon>
      </div>
    </div> -->
  </v-container>
</template>

<script>
export default {
  methods: {
    facebook() {
      window.location.href = 'https://www.facebook.com/zwizai'
    },
    messenger() {
      window.location.href = 'https://m.me/361231620965547'
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  // max-width: 800px !important;
}
.messenger {
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 10px 20px #00000029;
}
p {
  font-size: 15px;
  font-weight: 300;
}
</style>
